module.exports = __webpack_public_path__ + "img/Ute_Front_Side_Right_Transparent.66e52143.svg";